import { render } from "./PartnerDetailsView.vue?vue&type=template&id=f18ae6b6&scoped=true"
import script from "./PartnerDetailsView.vue?vue&type=script&lang=js"
export * from "./PartnerDetailsView.vue?vue&type=script&lang=js"

import "./PartnerDetailsView.vue?vue&type=style&index=0&id=f18ae6b6&scoped=true&lang=css"

import exportComponent from "C:\\Users\\lenovo\\Desktop\\canadianlic\\client\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f18ae6b6"]])

export default __exports__